import React from 'react'
import styled from '@emotion/styled'
import CountryTag from './CountryTag'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 10px 0;
`

const Add = styled.img`
  margin-left: 8px;
  width: 20px;
  height: 20px;
  cursor: pointer;
`

const arr = (new Array(8)).fill(0)

const CountryTags = () => {

  return (
    <Container>
      {arr.map(() => <CountryTag />)}
      <Add alt="add-icon" src="https://cdn-icons-png.flaticon.com/512/1828/1828919.png" />
    </Container>
  )
}

export default CountryTags